import React from 'react'
import Link, { withPrefix } from 'gatsby-link'
import Helmet from 'react-helmet'
import { observer, inject } from 'mobx-react'
import { Form, Container, Header, Image, Icon, Button, Message } from 'semantic-ui-react'

@inject('UserStore')
@observer
class ReferralsPage extends React.Component {
  render () {
    const { handleChange, issueReferralCode } = this.props.UserStore
    const { _issuedReferralCode, loading } = this.props.UserStore
    return <Container text textAlign='left'>
      <Helmet>
        <title>Рекомендуй друзьям и получай БЕСПЛАТНЫЕ билеты - Fake Flight Tickets</title>
        <meta name="twitter:title" content='Рекомендуй друзьям и получи скидки - Fake Flight Tickets' />
        <meta name="twitter:image" content='/opengraph-image.ru.jpg' />
        <meta property="og:image" content='/opengraph-image.ru.jpg' />
      </Helmet>
      <Header as='h1'>
        Рекомендуй друзьям —<br/> получай БЕСПЛАТНЫЕ билеты!
      </Header>
      <Image src='https://jvcorp-wpengine.netdna-ssl.com/wp-content/uploads/2014/06/AndyDwyerSmall-1.gif' rounded />
      <p>
        Каждый раз когда 3 друга покупают через твою ссылку,<br/>
        ты зарабатываешь БЕСПЛАТНЫЙ билет.<br/>
        Поделись своей ссылкой на соц медия, группах и в своём блоге
      </p>
      <Form>
        <Form.Group inline>
          <Form.Input name='firstName' placeholder='Твоё имя' onChange={handleChange} />
          <Form.Input name='email' placeholder='твой@mail.ru' onChange={handleChange} />
          <Form.Button content='Получить код' color='green' onClick={issueReferralCode} {...{loading}} />
        </Form.Group>
      </Form>
      {_issuedReferralCode && <Message icon='check' header='Проверь свой имэйл' content="Your referral link is on the way!" positive />}

    </Container>
  }
}

export default ReferralsPage



// WEBPACK FOOTER //
// ./src/pages/referrals.ru.js